import _ from 'lodash'

import { DoorIcon } from '@hugeicons/react'
import Countdown from 'react-countdown'

import { getInstagramUsername } from '@/shared/lib/string/instagram-username'
import { Button } from '@/shared/ui/Button'
import { Card } from '@/shared/ui'

const TimeUnit = ({ value, label, size = 'lg' }) => {
  const boxSize = size === 'lg' ? 'w-[50px] h-[50px] text-3xl' : 'w-[40px] h-[40px] text-xl'
  return (
    <div className="flex flex-col items-center justify-center">
      <div className={`leading-none border-2 border-brand text-gray-700 rounded-xl flex items-center justify-center mb-2 font-bold ${boxSize}`}>
        {value}
      </div>
      <span className="block text-caps font-extrabold uppercase text-gray-700 leading-none">
        {label}
      </span>
    </div>
  )
}

export const CountdownPage = ({
  digitalProduct,
  status,
  startAt,
  onComplete
}) => {
  const socialNetworks = _.get(
    digitalProduct,
    'gamification_meta.social_networks'
  )

  return (
    <div className="container px-6 min-h-dvh flex flex-col justify-center">
      <div className="flex justify-center">
        <div className="w-full md:max-w-[50%]">
          <Card>
            <Card.Body className="flex flex-col items-center justify-center py-20 text-2xl font-bold">
              <img
                id="logo"
                alt="Logo"
                src={
                  _.get(digitalProduct, 'logo.file.url') || '/logo-dark-alt.png'
                }
                className="h-[90px] lg:h-[100px] xl:h-[120px] mb-8"
              />
              {status == 'soon' && (
                <Countdown
                  date={startAt}
                  zeroPadTime={2}
                  renderer={({ days, hours, minutes, seconds, completed }) =>
                    completed ? (
                      <>
                        <span className="block text-center text-base text-gray-800">
                          O{' '}
                          <span className="text-brand">
                            {digitalProduct?.name}
                          </span>{' '}
                          começou!
                        </span>
                        <span className="block text-center text-sm mb-3 text-gray-800 mt-4">
                          Clique no botão abaixo para iniciar
                        </span>
                        <Button
                          onClick={() => location.reload(true)}
                          variant="primary"
                          showTrailingIcon={false}
                          leadingIcon={<DoorIcon variant="duotone" size={18} />}
                        >
                          Entrar
                        </Button>
                      </>
                    ) : (
                      <>
                        <span className="block text-center text-base mb-6 text-gray-800">
                          O{' '}
                          <span className="text-brand">
                            {digitalProduct?.name}
                          </span>{' '}
                          começa em
                        </span>
                        <div className="flex items-center justify-center gap-6">
                          {days > 0 && (
                            <TimeUnit value={days} label={`Dia${days == 1 ? '' : 's'}`} />
                          )}
                          <TimeUnit value={hours} label={`Hora${hours == 1 ? '' : 's'}`} />
                          <TimeUnit value={minutes} label={`Minuto${minutes == 1 ? '' : 's'}`} />
                          <TimeUnit value={seconds} label={`Segundo${seconds == 1 ? '' : 's'}`} />
                        </div>
                        {socialNetworks?.instagram && (
                          <span className="block text-center text-sm mb-3 text-gray-800 mt-4">
                            Enquanto aguarda, visite nosso instagram{' '}
                            <a
                              href={`https://www.instagram.com/${getInstagramUsername(
                                socialNetworks?.instagram
                              )}`}
                              target="_blank"
                              className="text-brand underline"
                            >
                              @
                              {getInstagramUsername(
                                socialNetworks?.instagram
                              )}
                            </a>
                          </span>
                        )}
                      </>
                    )
                  }
                  onComplete={onComplete}
                />
              )}
              {status == 'closed' && (
                <>
                  <span className="block text-center text-base text-gray-800">
                    O{' '}
                    <span className="text-brand">{digitalProduct?.name}</span>{' '}
                    foi encerrado
                  </span>
                  {socialNetworks?.instagram && (
                    <span className="block text-center text-sm mb-3 text-gray-800 mt-4">
                      Continue a experiência através do nosso instagram{' '}
                      <a
                        href={`https://www.instagram.com/${getInstagramUsername(
                          socialNetworks?.instagram
                        )}`}
                        target="_blank"
                        className="text-brand underline"
                      >
                        @{getInstagramUsername(socialNetworks?.instagram)}
                      </a>
                    </span>
                  )}
                </>
              )}
              {status == 'open' && (
                <>
                  <span className="block text-center text-base text-gray-800">
                    O{' '}
                    <span className="text-brand">{digitalProduct?.name}</span>{' '}
                    começou!
                  </span>
                  <span className="block text-center text-sm mb-3 text-gray-800 mt-4">
                    Clique no botão abaixo para iniciar
                  </span>
                  <Button
                    onClick={() => location.reload(true)}
                    variant="primary"
                    showTrailingIcon={false}
                    leadingIcon={<DoorIcon variant="duotone" size={18} />}
                  >
                    Entrar
                  </Button>
                </>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  )
}

export const CountdownWidget = ({
  digitalProduct,
  status,
  startAt,
  onComplete
}) => {
  return (
    <Card className="rounded-none">
      <Card.Body className="py-4">
        {status == 'soon' && (
          <Countdown
            date={startAt}
            zeroPadTime={2}
            renderer={({ days, hours, minutes, seconds, completed }) =>
              completed ? (
                <></>
              ) : (
                <div className="flex items-center justify-between text-2xl font-bold">
                  <span className="block text-left text-sm text-gray-800 max-w-[150px]">
                    O{' '}
                    <span className="text-brand">{digitalProduct?.name}</span>{' '}
                    fica disponível em
                  </span>
                  <div className="flex items-center justify-center gap-4">
                    {days > 0 && (
                      <TimeUnit value={days} label={`Dia${days == 1 ? '' : 's'}`} size="sm" />
                    )}
                    <TimeUnit value={hours} label={`Hora${hours == 1 ? '' : 's'}`} size="sm" />
                    <TimeUnit value={minutes} label={`Min${minutes == 1 ? '' : 's'}`} size="sm" />
                    <TimeUnit value={seconds} label={`Seg${seconds == 1 ? '' : 's'}`} size="sm" />
                  </div>
                </div>
              )
            }
            onComplete={onComplete}
          />
        )}
        {status == 'closed' && (
          <span className="block text-center text-base text-gray-800 text-2xl font-bold">
            O <span className="text-brand">{digitalProduct?.name}</span> foi
            encerrado
          </span>
        )}
      </Card.Body>
    </Card>
  )
}
